import React, { useEffect, useState } from 'react';
import { Form, Button, Col, Row, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { getRoles } from '../../../../services/RoleService';
import { createModuleToRole } from '../../../../services/ModuleToRoleService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Define module options with operations
const moduleOptions = [
  { value: 'forms', label: 'Forms', operations: ['menu', 'view'] },
  { value: 'settings', label: 'Settings', operations: ['menu', 'view'] },
  { value: 'report', label: 'Report', operations: ['menu', 'read', 'export'] },
  { value: 'coi-report', label: 'COI Report', operations: ['menu', 'read', 'export'] },
  {
    value: 'dashboard',
    label: 'Dashboard',
    operations: [
      'menu',
      'read',
      'write',
      'edit',
      'delete',
      'export',
      'import',
      'jha-filter',
      'voucher-filter',
      'tripreport-filter',
      'award-filter',
      'coi-filter',
      'aea-filter',
    ],
  },
  {
    value: 'jha-form',
    label: 'JHA form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'voucher-form',
    label: 'Voucher form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'tripreport-form',
    label: 'Trip report form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'award-form',
    label: 'Award form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'aea-form',
    label: 'AEA form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'coi-form',
    label: 'COI form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'requisition-form',
    label: 'Requisition form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'training-form',
    label: 'Training form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'skills-form',
    label: 'Skills form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import', 'employeelist'],
  },
  {
    value: 'skills-dashboard',
    label: 'Skills Dashboard',
    operations: ['nemu', 'read', 'fulldashboard'],
  },
  {
    value: 'offer-form',
    label: 'Offer form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'mcft-form',
    label: 'MCFT form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'eww-form',
    label: 'EWW form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'shs-form',
    label: 'SHS form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  {
    value: 'fsr-form',
    label: 'FSR form',
    operations: ['menu', 'submit', 'edit', 'delete', 'read', 'export', 'import'],
  },
  { value: 'box-folders', label: 'Box Folder', operations: ['menu', 'show'] },
  {
    value: 'account-code-settings',
    label: 'Account Code Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'jha-job-settings',
    label: 'JHA Job Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'mtr-settings',
    label: 'MTR Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'project-code-settings',
    label: 'Project Code Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'roles-settings',
    label: 'Roles Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'fbr-settings',
    label: 'FBR Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'box-folders-settings',
    label: 'Box Folders Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'mte-settings',
    label: 'MTE Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'user-settings',
    label: 'User Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'task-number-settings',
    label: 'Task Number Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'award-type-settings',
    label: 'Award Type Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'award-ceremony-settings',
    label: 'Award ceremony Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: ' award-history-settings',
    label: 'Award History Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: ' training-history-settings',
    label: 'Training History Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'tuition-settings',
    label: 'Tuition Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'course-type-settings',
    label: 'Course Type Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'skill-category-settings',
    label: 'Skill Category Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'skill-expertise-settings',
    label: 'Skill Expertise Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'skills-settings',
    label: 'Skills Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'jobtitle-settings',
    label: 'Job Title Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'jobtype-settings',
    label: 'Job Type Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
  {
    value: 'subcontractor-settings',
    label: 'Subcontractor Settings',
    operations: ['menu', 'read', 'write', 'edit', 'delete', 'export', 'import'],
  },
];

const validationSchema = Yup.object().shape({
  roleSlug: Yup.string().required('Role is required'),
  modules: Yup.array().min(1, 'At least one module must be selected'),
});

function AddModuleToRole() {
  const navigate = useNavigate();
  const [roleList, setRoleList] = useState([]);

  useEffect(() => {
    const getListRole = async () => {
      const res = await getRoles();
      setRoleList(res);
    };
    getListRole();
  }, []);

  const roleOptions = roleList.map((role) => ({
    value: role.slug,
    label: role.label,
  }));

  const moduleOptionsWithOperations = moduleOptions.map((module) => ({
    value: module.value,
    label: module.label,
  }));

  const operationOptions = moduleOptions.reduce((acc, module) => {
    acc[module.value] = module.operations.map((op) => ({
      value: op,
      label: op.charAt(0).toUpperCase() + op.slice(1),
    }));
    return acc;
  }, {});

  const initialValues = {
    roleSlug: '',
    modules: [],
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await createModuleToRole({
        roleSlug: values.roleSlug,
        modules: values.modules.map((module) => ({
          value: module.value,
          operations: module.operations,
        })),
      });
      // Show success toast notification
      toast.success('Module added Successfully!', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate('/settings/mtr');
      }, 3000);
      console.log('Module added successfully');
    } catch (error) {
      console.error('Error adding role:', error);
      toast.error('Failed to adding Module !', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
    setSubmitting(false);
  };

  return (
    <>
      <Card>
        <h4 className="box-title">Add Module Details</h4>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, handleSubmit, isSubmitting }) => (
            <Form id="userUpdateForm" onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Col>
                  <Form.Group controlId="formRoleSlug">
                    <Form.Label>Role</Form.Label>
                    <Field name="roleSlug">
                      {({ field }) => (
                        <Select
                          {...field}
                          options={roleOptions}
                          value={roleOptions.find((option) => option.value === values.roleSlug)}
                          onChange={(selectedOption) =>
                            setFieldValue('roleSlug', selectedOption ? selectedOption.value : '')
                          }
                          placeholder="Select Role"
                        />
                      )}
                    </Field>
                    <ErrorMessage name="roleSlug" component="div" className="text-danger" />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="formModules">
                    <Form.Label>Modules</Form.Label>
                    <Field name="modules">
                      {({ field }) => (
                        <Select
                          {...field}
                          isMulti
                          options={moduleOptionsWithOperations}
                          value={values.modules}
                          onChange={(selectedModules) => {
                            setFieldValue(
                              'modules',
                              selectedModules.map((module) => ({
                                ...module,
                                operations:
                                  values.modules.find((m) => m.value === module.value)
                                    ?.operations || [],
                              }))
                            );
                          }}
                          placeholder="Select Modules"
                        />
                      )}
                    </Field>
                    <ErrorMessage name="modules" component="div" className="text-danger" />
                  </Form.Group>
                  {values.modules.map((module) => (
                    <div key={module.value} className="mb-3">
                      <Form.Label>Operations for {module.label}</Form.Label>
                      <Select
                        isMulti
                        name={`operations-${module.value}`}
                        value={module.operations.map((op) => ({
                          value: op,
                          label: op.charAt(0).toUpperCase() + op.slice(1),
                        }))}
                        onChange={(selectedOperations) => {
                          setFieldValue(
                            'modules',
                            values.modules.map((m) =>
                              m.value === module.value
                                ? {
                                    ...m,
                                    operations: selectedOperations.map((op) => op.value),
                                  }
                                : m
                            )
                          );
                        }}
                        options={operationOptions[module.value]}
                        placeholder="Select Operations"
                      />
                    </div>
                  ))}
                </Col>
              </Row>
              <div className="d-flex justify-content-end">
                <Button
                  variant="warning"
                  className="me-1 btn-danger"
                  onClick={() => navigate('/settings/mtr')}
                >
                  <i className="ti ti-trash"></i>
                </Button>
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                  <i className="ti ti-save-alt"></i> Save
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Card>
      <ToastContainer />
    </>
  );
}
export default AddModuleToRole;
